var React = require('react');

function ShowMore (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22.5","cy":"22.5","r":"22","transform":"rotate(-90 22.5 22.5)","fill":"white","stroke":"currentColor","key":0}),React.createElement("path",{"d":"M22 14L22 26.17L16.41 20.58L15 22L23 30L31 22L29.59 20.59L24 26.17L24 14L22 14Z","key":1})]);
}

ShowMore.defaultProps = {"width":"45","height":"45","viewBox":"0 0 45 45","fill":"currentColor"};

module.exports = ShowMore;

ShowMore.default = ShowMore;
